var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('trac-tab-window',{attrs:{"sectionTitle":'Integrations',"subLinks":_vm.subLinks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }